export default "__VITE_ASSET__o3KpbSWW__"